import styles from "./VirtualIssuedCard.module.scss";

const ContactlessIcon = () => (
  <svg
    className={styles.contactless}
    viewBox="0 0 32 32"
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.5 22c-1.5-2-2.5-4.5-2.5-7s1-5 2.5-7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M12 19c-1-1.5-1.5-3.2-1.5-5s.5-3.5 1.5-5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M15.5 16.5c-.4-.8-.6-1.6-.6-2.5s.2-1.7.6-2.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M19 15c-.2-.5-.3-1-.3-1.5s.1-1 .3-1.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

const VirtualIssuedCard = ({
  cardCategoryLabel,
  lastFour,
  holderName,
  expiryLabel,
  statusText,
  cardType,
  onViewCard,
}) => {
  const pan = `**** **** **** ${lastFour || "****"}`;
  const category = (cardCategoryLabel || "VIRTUAL").toUpperCase();

  return (
    <div
      className={`${styles.card} ${cardType === "CREDIT" ? styles.creditAccent : ""}`}
      role="img"
      aria-label={`${category} card ending ${lastFour || "unknown"}`}
    >
      <div className={styles.inner}>
        <div className={styles.topRow}>
          <ContactlessIcon />
          {/* <span className={styles.badge}>{category}</span> */}
        </div>
        <div className={styles.midRow}>
          <div className={styles.chip} aria-hidden />
          <div className={styles.pan}>{pan}</div>
        </div>
        <div className={styles.bottomRow}>
          <div className={`${styles.holderBlock} ${styles.holderBlockLeft}`}>
            <span className={styles.label}>Card holder name</span>
            <div className={styles.name}>{holderName || "—"}</div>
          </div>
          <div className={styles.expiryBlock}>
            <span className={styles.label}>Expiry date</span>
            <div className={styles.expiry}>{expiryLabel || "—/—"}</div>
          </div>
          {typeof onViewCard === "function" ? (
            <button type="button" className={styles.viewBtn} onClick={onViewCard}>
              View Card
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default VirtualIssuedCard;
